import { Box, Button, Drawer, Stack, Tooltip } from '@mui/material'
import React, { Component } from 'react'
import { Colors } from '../../../Styles/Colors'
import { ImagePaths } from '../../../Utility/ImagePaths'
import ToastMsg from '../../../Components/ToastMsg/ToastMsg'
import { DataGrid } from '@mui/x-data-grid'
import { CommonGridToolBarWithFilterText } from '../../../Components/Common Components/CommonComponents'
import SubLocReportFilter from './SubLocReportFilter'
import RestAPIService from '../../../Utility/Services/RestAPIService'
import { Serviceurls } from '../../../Utility/API/Serviceurls'
import { CheckAccessFunc } from '../../../Components/CommonFunctions/CommonFunctions'

const data = [
  { brand_name: 'Test', generic_name: "Generic", dosage_type: "Tablet", dosage_strength: '20 ML', available_qty: '50', request_qty: null },
  { brand_name: 'Test Two', generic_name: "Generic Two", dosage_type: "Tablet", dosage_strength: '65 ML', available_qty: '50', request_qty: null },
]
export default class SubLocStockExpiry extends Component {
  constructor(props) {
    super(props)
    this.state = {
      stockExpiryData: [],
      page: 0,
      pageSize: 10,
      returnDrugList: [],
      filterDatas: {
        'months': 1,
        'brandName':'',
        'toLocationName': null,
      },
      pageName: "StockExpiry",
      filterOpen: false,
      isMultiPharmacy: false,
      selectedPharmacyId: null,
    }
  }

  componentDidMount() {
    this.getToLocationListData();
    this.getStockExpiryListData();
  }

  getStockExpiryListData = () => {
    try {
      const {filterDatas} = this.state;
      RestAPIService.getAll(Serviceurls.SUBLOC_STOCK_EXPIRY_REPORT_GET + `?month=${filterDatas.months}&brand_name=${filterDatas.brandName}&from_pharmacy_id=${filterDatas?.toLocationName?.pharmacy_id || ""}`)
        .then((response) => {
          if (response.data.status === 'success') {
            this.setState({
              stockExpiryData: response.data.data
            })
          }
        }).catch((error) => {
          if (error?.response?.data?.message) {
            this.errorMessage(error.response.data.message)
          } else {
            this.errorMessage(error.message)
          }
        })
    } catch (error) {
      this.errorMessage(error.message)
    }
  }

  getToLocationListData = () => {
    try {
        RestAPIService.getAll(Serviceurls.SUBLOC_FROM_LOCATION_GET)
            .then((response) => {
                if (response.data.status === 'success') {   
                  this.setState({
                    isMultiPharmacy: response.data.data?.filter((item) => item.is_primary_pharmacy)?.length > 1 || false
                  })
                }
            }).catch((error) => {
                if (error?.response?.data?.message) {
                    this.errorMessage(error.response.data.message)
                } else {
                    this.errorMessage(error.message)
                }
            })
    } catch (error) {
        this.errorMessage(error.message)
    }
}

  getShortExpiryPrint = () => {
    const {filterDatas} = this.state;
    try {
      RestAPIService.getAll(Serviceurls.SUBLOC_STOCK_EXPIRY_REPORT_GET + `?export_type=pdf&month=${filterDatas.months}&from_pharmacy_id=${filterDatas?.toLocationName?.pharmacy_id || ""}`)
        .then((response) => {
          const file = new Blob(
            [response.data],
            { type: 'application/pdf' });
          const fileURL = URL.createObjectURL(file);
          window.open(fileURL);
        }).catch((error) => {
          this.errorMessage(error.message)
        })
    } catch (error) {
      this.errorMessage(error.message)
    }
  }

  errorMessage = (message) => {
    this.setState({
      isErrorMsg: true,
      isErrorMsgText: message
    })
  }

  successMessage = (message) => {
    this.setState({
      successMsg: true,
      successMsgText: message
    })
  }

  msgClose() {
    this.setState({
      isErrorMsg: false,
      isErrorMsgText: '',
      successMsg: false,
      successMsgText: ''
    })
  }

  ClosePopUp() {
    this.setState({
      filterOpen: false,
    })
  }

  clearFilter = (data) => {
    this.setState({
      filterDatas: data
    })
  }

  renderFilter = (data) => {
    this.setState({
      filterDatas: data,
      filterOpen: false,
    }, () => {
      this.getStockExpiryListData()
    })
  }

  gridToolBar = () => {
    let TextArray = [
      // { label: "From Date", value: this.state.filterDatas.fromDate },
      // { label: "To Date", value: this.state.filterDatas.toDate }
    ]
    return (
      <Box>
        <CommonGridToolBarWithFilterText FilterTextArray={TextArray} />
      </Box>
    )
  }

  onClickCheckBoxHandler = (ids) => {
    try {
      const selectedIds = new Set(ids);
      const selectedRows = this.state.stockExpiryData?.filter((row) => selectedIds.has(row.sno));
      if (selectedRows.length > 0) {
        const selectedPharmaId = selectedRows[0]?.from_pharmacy_id;
        const isDiffPharmaFound = selectedRows.some((item) => item?.from_pharmacy_id !== selectedPharmaId);
        if (isDiffPharmaFound) {
          this.errorMessage("Drugs from multiple pharmacies cannot be included in a single request.")
        } else {
          this.setState({
            selectedPharmacyId: {
              pharmacy_id: selectedRows[0]?.from_pharmacy_id,
              module_name: selectedRows[0]?.from_pharmacy_name
            },
            returnDrugList: selectedRows,
          });
        }
      } else {
        this.setState({ selectedPharmacyId: null, returnDrugList: [] });
      }
    } catch (error) {
      this.errorMessage(error.message);
    }
  };

  dateformate(dateString){
    const dateParts = dateString.split('-'); // Split the string into an array
    
    const month = dateParts[1]; // Get the month part
    const year = dateParts[0];  // Get the year part
    
    const formattedDate = `${month}-${year}`; // Format it as 'MM-YYYY'
    return formattedDate ; // Output: '10-2024'
  }

  render() {
    this.state.stockExpiryData.forEach((element, index) => element.sno = index + 1)
    const column = [
      {
        field: 'brand_name', headerName: 'Brand Name', flex: 0.143,
        renderCell: (params) => (<Box>{params?.row?.brand_name ? params?.row?.brand_name : '-'}</Box>)
      },
      {
        field: 'dosage_type', headerName: 'Dosage Type', flex: 0.143,
        renderCell: (params) => (<Box>{params?.row?.dosage_type ? params?.row?.dosage_type : '-'}</Box>)
      },
      {
        field: 'dosage_strength', headerName: 'Dosage Strength', flex: 0.143,
        renderCell: (params) => (<Box>{params?.row?.dosage_strength ? params?.row?.dosage_strength : '-'}</Box>)
      },
      {
        field: 'batch_no', headerName: 'Batch No.', flex: 0.143,
        renderCell: (params) => (<Box>{params?.row?.batch_no ? params?.row?.batch_no : '-'}</Box>)
      },
      {
        field: 'expiry_date', headerName: 'Expiry Date', flex: 0.143,
        renderCell: (params) => (<Box>{params?.row?.expiry_date ? this.dateformate(params?.row?.expiry_date) : '-'}</Box>)
      },
      {
        field: 'stock_in_quantity', headerName: 'Available Stock', flex: 0.143,
        renderCell: (params) => (<Box>{params?.row?.stock_in_quantity ? params?.row?.stock_in_quantity : '-'}</Box>)
      },
      {
        field: 'request_qty', headerName: 'To Location', flex: 0.143,
        renderCell: (params) => (
          <Box>{params?.row?.available_qty ? params?.row?.available_qty : '-'}</Box>
        )
      }
    ]

    if (this.state.isMultiPharmacy) {
      column.splice(6, 0, {
        field: 'from_pharmacy_name', headerName: 'Pharmacy Name', flex: 0.143,
        renderCell: (params) => (<Box>{params?.row?.from_pharmacy_name ?
          params?.row?.from_pharmacy_name?.length > 20 ?
            <Tooltip placement='top' title={params?.row?.from_pharmacy_name} arrow>
              <Box>{params?.row?.from_pharmacy_name.slice(0, 20) + '...'}</Box></Tooltip>
            : params?.row?.from_pharmacy_name : '-'}</Box>)
      })
    }

    return (
      <Box component={'div'} sx={{ backgroundColor: Colors.Background, height: '80vh' }}>
        <Box component={'div'} height={'8vh'} display={'flex'} justifyContent={'flex-end'} alignItems={'center'}>
          <Box display={'flex'} alignItems={'center'}>
            <Button
              size='small'
              disabled={CheckAccessFunc("sub_location", "Reports", "Short Expiry",  null, "Tab")?.editAccess === false}
              sx={{ mr: '1vw', height: '2vw', textTransform: 'capitalize' }}
              variant='contained'
              endIcon={this.state.returnDrugList?.length ? `(${this.state.returnDrugList?.length})` : null}
              onClick={() => {
                if (this.state.returnDrugList?.length > 0) {
                  this.props.history.push({
                    pathname: "/SubLocationStockTransfer/RaiseRequest",
                    state: {
                      drugRequestList: this.state.returnDrugList,
                      page: "stockExpiry",
                      selectedPharmacy: this.state.selectedPharmacyId
                    }
                  })
                } else {
                  this.errorMessage("Select atleast one drug from the list")
                }
              }}
            >Return Request</Button>
          </Box>
          <Box component={'div'} borderLeft={'2px solid gray'} pl={'1vw'}>
            <Button
              className='Common_Btn_Min_Width'
              sx={{ height: '2.5vw', width: '2.5vw' }}
              onClick={() => this.setState({ filterOpen: true })}
            >
              <Box component={'img'} src={ImagePaths.Filter.default} height={'2vw'} width={'2vw'} alt='filter' />
            </Button>
            <Button
              className='Common_Btn_Min_Width'
              sx={{ height: '2.5vw', width: '2.5vw',mr: '0.5vw' }}
              onClick={() => this.getShortExpiryPrint()}
            >
              <Box component={'img'} src={ImagePaths.LabPrintIcon.default} height={'2vw'} width={'2vw'} alt='filter' />
            </Button>
            {/* <Button className='Common_Btn_Min_Width' sx={{ height: '2.5vw', width: '2.5vw', mr: '0.5vw' }}>
              <Box component={'img'} src={ImagePaths.ExportIcon.default} height={'2vw'} width={'2vw'} alt='filter' />
            </Button> */}
          </Box>
        </Box>
        <Box component={'div'} height={'72vh'} padding={'0.5vw'}>
          <DataGrid
            checkboxSelection
            onSelectionModelChange={(ids) => { this.onClickCheckBoxHandler(ids) }}
            sx={{ backgroundColor: 'white' }}
            columns={column}
            disableColumnFilter
            rows={this.state.stockExpiryData}
            getRowId={(row) => row['sno']}
            page={this.state.page}
            pageSize={this.state.pageSize}
            localeText={{
              toolbarColumns: "",
              toolbarDensity: "",
              toolbarExport: "",
              toolbarFilters: "",
              toolbarExportPrint: ""
            }}
            components={{
              Toolbar: this.gridToolBar,
              NoRowsOverlay: () => (
                <Stack className='eMed_conf_nodata'>
                  {'No Records To Be Shown'}
                </Stack>
              )
            }}
            onPageChange={(newPage) => { this.setState({ page: newPage }) }}
            onPageSizeChange={(newPageSize) => this.setState({ pageSize: newPageSize })}
            rowsPerPageOptions={[10, 20, 30]}
            pagination
            headerHeight={40}
            disableSelectionOnClick
          />
        </Box>
        <Drawer
          anchor={'right'}
          open={this.state.filterOpen}
          ModalProps={{ onBackdropClick: this.ClosePopUp.bind(this) }}
        >
          <SubLocReportFilter
            pageName={this.state.pageName}
            filterDatas={this.state.filterDatas}
            closeFilter={this.ClosePopUp.bind(this)}
            filteredData={this.renderFilter.bind(this)}
            ClearData={this.clearFilter.bind(this)} />
        </Drawer>
        {this.state.isErrorMsg ?
          <ToastMsg
            severity={'error'}
            msg={this.state.isErrorMsgText}
            msgPop={this.msgClose.bind(this)}
          />
          : null}
        {this.state.successMsg ?
          <ToastMsg
            severity={'success'}
            msg={this.state.successMsgText}
            msgPop={this.msgClose.bind(this)}
          />
          : null}
      </Box>
    )
  }
}
